module.exports = __webpack_public_path__ + "5926d9e2d82c45a92be55a5368b9cc8c.png";